module.exports = __webpack_public_path__ + "static/img/playIGTC.7229bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainMenu/playIGTC.png
// module id = XM0H
// module chunks = 0